var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowOpenUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49992 8.97529L6.37044 12.1049L4.83496 10.5694L9.49992 5.89504L14.165 10.5692L12.6295 12.1047L9.49992 8.97529Z",
    fill: "#989FAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowOpenUp);
export default __webpack_public_path__ + "static/media/icon_arrow_open_up.e01da4682686990f3a867941cf1f4121.svg";
export { ForwardRef as ReactComponent };